
import { mapState } from 'vuex'
import { mdiMinusCircleOutline, mdiPlusCircleOutline } from '@mdi/js'
import FaqMerchantAnswerExec from '../ui/faq/FaqMerchantAnswerExec.vue'
import { Cms } from '@/helpers/cms'

export default {
  icons: { mdiMinusCircleOutline, mdiPlusCircleOutline },
  components: { FaqMerchantAnswerExec },
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    faqSections: []
  }),
  async fetch () {
    const storeCode = this.$i18n.locale

    const url = this.$config.cmsBaseURL + '/api/merchant-faq?populate[sections][populate]=*'
    if (storeCode === 'de') {
      const cms = new Cms(this.$axios)
      const { data } = await cms.get(url)
      this.faqSections = data?.attributes?.sections
    } else {
      const { data } = await this.$axios.post(`/public/translate/cms?storeCode=${storeCode}`, { url })
      this.faqSections = data?.data?.attributes?.sections
    }
  },
  computed: {
    ...mapState('customer', {
      merchantAcceptedByCm24: state => state.merchant?.acceptedByCm24
    }),
    show () {
      return this.$route.query.mc === this.$config.merchantAccessCode ||
        this.merchantAcceptedByCm24
    }
  }
}
